// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

window.cardScaleAnimation = function cardScaleAnimation() {
  const cardScaleElsArr = document.querySelectorAll(
    '[data-card-scale-animation]'
  );

  if (cardScaleElsArr.length) {
    cardScaleElsArr.forEach((el) => {
      if (!el.classList.contains('is-init-card-scale-animation')) {
        el.classList.add('is-init-card-scale-animation');

        let startY = 100;
        let endY = 20;

        let startTrigger = 90;
        let endTrigger = 10;

        if (el.hasAttribute('data-card-scale-animation-later-start')) {
          startTrigger = 70;
          endTrigger = 5;
          endY = 0;
        }

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: el,
            start: `top-=${startY}vh ${startTrigger}%`,
            end: `bottom+=${endY}vh ${endTrigger}%`,
            scrub: 0.85,
            // markers: true,
            invalidateOnRefresh: true,
            /*onUpdate: (self) => {
              const progress = self.progress;
            },*/
          },
        });

        tl.fromTo(
          el,
          {
            scale: 0.9,
          },
          {
            scale: 1,
            duration: 0.6,
            ease: 'power2.out',
          }
        );
      }
    });
  }
};

if (!document.querySelector('.bold-loader-new')) {
  cardScaleAnimation();
}
